// extracted by mini-css-extract-plugin
export var BaseTable__rowExpanded = "Dishes-module--BaseTable__row--expanded--CWouS";
export var actionButtonContainer = "Dishes-module--actionButtonContainer--JsAu2";
export var container = "Dishes-module--container--RMlMf";
export var content = "Dishes-module--content--UTEB6";
export var item = "Dishes-module--item--d3yEk";
export var noItems = "Dishes-module--noItems--TlCGL";
export var noSuppliers = "Dishes-module--noSuppliers--uxc0y";
export var subHeader = "Dishes-module--subHeader--UGRW7";